import {EventEmitter, Injectable} from '@angular/core';
import { ModuleAuthService } from '@services/moduleAuth/module-auth.service';
import {LocalStorageService} from 'ngx-webstorage';
import {TRASecurityModule} from '@common_libraries/lib/Enums';
import {Observable} from 'rxjs';

@Injectable()
export class ModuleAuth {
  public AuthChange: EventEmitter<any> = new EventEmitter();

  constructor(private moduleAuthService: ModuleAuthService, private localSt: LocalStorageService) {

  }

  public SetupModuleAuthData(): Observable<any> {

    const successObs = Observable.create(observer => {
      this.moduleAuthService.GetModulesForCurrentUser().subscribe((result: any) => {
        this.localSt.store('ModuleAuthData', result.json.data);
        observer.next();
        observer.complete();
        this.AuthChange.emit(result.json.data);
      });
    });

    return successObs;
  }

  public IsUserAuthed(module: TRASecurityModule): boolean {

    const moduleAuthData = this.localSt.retrieve('ModuleAuthData');

    if (moduleAuthData == null || moduleAuthData.valid === false) {
      return false;
    }

    const moduleIDs = moduleAuthData.moduleIDs.filter((item) => {
      return item === module;
    });

    if (moduleAuthData.superAdmin === true || moduleIDs.length > 0) {
      return true;
    } else {
      return false;
    }

  }

  public IsUserAuthedNoSuper(module: TRASecurityModule): boolean {
    
    const moduleAuthData = this.localSt.retrieve('ModuleAuthData');

    if (moduleAuthData == null || moduleAuthData.valid === false) {
      return false;
    }

    const moduleIDs = moduleAuthData.moduleIDs.filter((item) => {
      return item === module;
    });

    if ( moduleIDs.length > 0) {
      return true;
    } else {
      return false;
    }

  }

  public UserHasModuldeAuthData(): boolean {

    const moduleAuthData = this.localSt.retrieve('ModuleAuthData');

    if (moduleAuthData == null || moduleAuthData.valid === false) {
      return false;
    }  else {
     return true;
   }

  }

  public IsUserSuperAdmin(): boolean {
    const moduleAuthData = this.localSt.retrieve('ModuleAuthData');

    if (moduleAuthData == null || moduleAuthData.valid === false) {
      return false;
    }

    if (moduleAuthData.superAdmin === true) {
      return true;
    } else {
      return false;
    }
  }


}
